(function ($) {
  'use strict';

  var MOBILE_BREAKPOINT = 1024;
  var SECTION_SELECTOR = '.product-main-section';
  var SLIDER_SELECTOR = '.mobile-slider';
  var resizeTimer;
  var variantTimers = [];

  function isMobileGallery() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function getSection() {
    return $(SECTION_SELECTOR).first();
  }

  function getSlider() {
    return getSection().find(SLIDER_SELECTOR).first();
  }

  function getProductData() {
    var node = getSection().find('[data-product-json]').get(0);

    if (!node) {
      return null;
    }

    try {
      return JSON.parse(node.textContent || node.innerHTML);
    } catch (error) {
      console.warn('Product gallery: product JSON could not be read.', error);
      return null;
    }
  }

  function getSelectedOptions() {
    var options = [];

    getSection().find('[data-single-option-selector]').each(function () {
      if (this.tagName === 'SELECT') {
        options.push(this.value);
      } else if (this.checked) {
        options.push(this.value);
      }
    });

    return options;
  }

  function getSelectedVariant(product) {
    var options = getSelectedOptions();
    var variant = null;

    if (product && Array.isArray(product.variants) && options.length) {
      variant = product.variants.find(function (item) {
        if (!Array.isArray(item.options) || item.options.length !== options.length) {
          return false;
        }

        return item.options.every(function (option, index) {
          return String(option) === String(options[index]);
        });
      });
    }

    if (variant) {
      return variant;
    }

    var idInput = getSection()
      .find('form[action*="/cart/add"] [name="id"]')
      .first();
    var variantId = idInput.length ? String(idInput.val()) : '';

    if (!variantId || !product || !Array.isArray(product.variants)) {
      return null;
    }

    return product.variants.find(function (item) {
      return String(item.id) === variantId;
    }) || null;
  }

  function getVariantMediaId(variant) {
    if (!variant) {
      return null;
    }

    if (variant.featured_media && variant.featured_media.id) {
      return String(variant.featured_media.id);
    }

    if (variant.featured_image && variant.featured_image.id) {
      return String(variant.featured_image.id);
    }

    return null;
  }

  function goToSelectedVariant() {
    if (!isMobileGallery()) {
      return;
    }

    var $slider = getSlider();

    if (!$slider.length || !$slider.hasClass('slick-initialized')) {
      return;
    }

    var product = getProductData();
    var variant = getSelectedVariant(product);
    var mediaId = getVariantMediaId(variant);

    if (!mediaId) {
      return;
    }

    var $media = $slider
      .find('.product-media-object[data-media-id="' + mediaId + '"]')
      .first();
    var $slide = $media.closest('.slick-slide');

    if (!$slide.length) {
      return;
    }

    var slideIndex = parseInt($slide.attr('data-slick-index'), 10);

    if (isNaN(slideIndex)) {
      return;
    }

    $slider.slick('slickGoTo', slideIndex, true);
    $slider.slick('setPosition');

    setTimeout(function () {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      }
    }, 150);
  }

  function clearVariantTimers() {
    variantTimers.forEach(function (timer) {
      clearTimeout(timer);
    });
    variantTimers = [];
  }

  function scheduleVariantSync() {
    if (!isMobileGallery()) {
      return;
    }

    clearVariantTimers();

    [0, 120, 650].forEach(function (delay) {
      variantTimers.push(setTimeout(goToSelectedVariant, delay));
    });
  }

  function initProductSlider() {
    var $slider = getSlider();

    if (!$slider.length || typeof $.fn.slick !== 'function') {
      return;
    }

    if (isMobileGallery()) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: false,
          adaptiveHeight: false,
          speed: 300,
          swipe: true,
          swipeToSlide: true,
          draggable: true,
          touchMove: true,
          accessibility: true
        });
      }

      scheduleVariantSync();
    } else if ($slider.hasClass('slick-initialized')) {
      clearVariantTimers();
      $slider.slick('unslick');
    }
  }

  function getPopupImages() {
    var images = [];
    var node = getSection().find('[data-product-gallery-json]').get(0);

    if (node) {
      try {
        var data = JSON.parse(node.textContent || node.innerHTML);
        if (Array.isArray(data)) {
          data.forEach(function (item) {
            if (typeof item === 'string') {
              images.push({ src: item, alt: '' });
            } else if (item && (item.src || item.url)) {
              images.push({ src: item.src || item.url, alt: item.alt || '' });
            }
          });
        }
      } catch (error) {
        console.warn('Product gallery: popup image JSON could not be read.', error);
      }
    }

    if (images.length) {
      return images;
    }

    getSlider().find('.product__media-item:not(.slick-cloned) img').each(function () {
      var src = '';
      var srcset = this.getAttribute('data-srcset') || this.getAttribute('srcset') || '';

      if (srcset) {
        var parts = srcset.split(',');
        src = parts[parts.length - 1].trim().split(' ')[0];
      }

      if (!src) {
        src = this.currentSrc || this.src || '';
      }

      if (src.indexOf('//') === 0) {
        src = 'https:' + src;
      }

      if (src) {
        images.push({ src: src, alt: this.alt || '' });
      }
    });

    return images;
  }

  $(document)
    .off('change.variantGalleryFix')
    .on(
      'change.variantGalleryFix',
      [
        SECTION_SELECTOR + ' [data-single-option-selector]',
        SECTION_SELECTOR + ' select[name^="options"]',
        SECTION_SELECTOR + ' input[name^="options"]',
        SECTION_SELECTOR + ' form[action*="/cart/add"] [name="id"]'
      ].join(','),
      scheduleVariantSync
    );

  $(document)
    .off('click.productThumb', SLIDER_SELECTOR + ' .product__media-item')
    .on('click.productThumb', SLIDER_SELECTOR + ' .product__media-item', function () {
      if (!isMobileGallery()) {
        return;
      }

      var $slider = getSlider();
      var slideIndex = parseInt($(this).attr('data-slick-index'), 10);

      if ($slider.hasClass('slick-initialized') && !isNaN(slideIndex)) {
        $slider.slick('slickGoTo', slideIndex, true);
      }
    });

  $(document)
    .off('click.productPopup', '.thumbwrap .product__media-item img')
    .on('click.productPopup', '.thumbwrap .product__media-item img', function () {
      if (!isMobileGallery()) {
        return;
      }

      var popup = document.getElementById('imagePopup');
      var popupGallery = document.getElementById('popupGallery');

      if (!popup || !popupGallery) {
        return;
      }

      popupGallery.innerHTML = '';

      getPopupImages().forEach(function (image) {
        if (!image || !image.src) {
          return;
        }

        var img = document.createElement('img');
        img.src = image.src;
        img.alt = image.alt || '';
        popupGallery.appendChild(img);
      });

      popup.classList.add('active');
      $('body').addClass('no-scroll');
    });

  $(document)
    .off('click.productPopupClose', '.popup-close')
    .on('click.productPopupClose', '.popup-close', function () {
      $('#imagePopup').removeClass('active');
      $('body').removeClass('no-scroll');
    });

  $(document)
    .off('keydown.productPopupClose')
    .on('keydown.productPopupClose', function (event) {
      if (event.key === 'Escape') {
        $('#imagePopup').removeClass('active');
        $('body').removeClass('no-scroll');
      }
    });

  $(document).ready(initProductSlider);

  $(window)
    .off('load.productSlider')
    .on('load.productSlider', initProductSlider)
    .off('resize.productSlider')
    .on('resize.productSlider', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initProductSlider, 200);
    });
})(jQuery);
